import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function IllustrationSpeechBubble(props) {
  return (
    <SvgIcon width="83" height="60" {...props}>
      <title>SpeechBubble</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.3 3.96103L4.35809 41.5956L43.8203 44.3419L45.4447 59.7L57.9224 44.1371L71.5148 44.7496L82.0667 4.26529L41.1823 0.299988L0.3 3.96103Z"
        fill="#368007"
      />
    </SvgIcon>
  );
}

export default IllustrationSpeechBubble;
